import {
  KevelAdBaseEntity,
  KevelAdBaseEntityParams,
} from "@shared/services/event_tracking/entities";

interface KevelSponsoredProductAdEntityParams extends KevelAdBaseEntityParams {
  placement_position?: number;
  product_line_id?: number;
}
export class KevelSponsoredProductAdEntity extends KevelAdBaseEntity {
  display_position: number;
  product_line_id: number;

  constructor(params: KevelSponsoredProductAdEntityParams) {
    super(params);
    this.type = "kevel_sponsored_product_ad";
    this.entity_version = 1;
    this.display_position = params.placement_position;
    this.product_line_id = params.product_line_id;
  }
}
